export const getProductParentIdEntry = (itemId, parentId) => ({
  [`${itemId}`]: `${parentId}`
});